import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const DeleteIconLine = ({ color, ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox="0 0 19 20" {...rest}>
     <g id="Favourites" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="7b-Favourites---Edit" transform="translate(-237.000000, -322.000000)" stroke={color}>
            <g id="Group-Copy-3" transform="translate(148.000000, 312.000000)">
                <g id="Can" transform="translate(89.333333, 10.000000)">
                    <polyline id="Path" points="6.30076923 6.24769231 6.25076923 16.7092308 6.28307692 16.7092308"></polyline>
                    <line x1="9.10846154" y1="6.24769231" x2="9.09" y2="16.7092308" id="Path"></line>
                    <line x1="11.9161538" y1="6.24769231" x2="11.8976923" y2="16.7092308" id="Path"></line>
                    <path d="M2.35692308,3.66846154 C2.35692308,3.66846154 3.04230769,17.2723077 3.1,17.8992308 C3.18334276,18.7807202 3.96074747,19.4308446 4.84307692,19.3569231 C6.04384615,19.3569231 12.5884615,19.3284615 13.2738462,19.3284615 C14.1573313,19.2412935 14.8841122,18.5949554 15.0738462,17.7276923 C15.1884615,16.8415385 15.7884615,3.66692308 15.7884615,3.66692308" id="Path"></path>
                    <line x1="0.384615385" y1="3.66923077" x2="17.7038462" y2="3.66923077" id="Path"></line>
                    <path d="M6.77923077,3.67230769 L6.77923077,3.13384615 C6.77923077,1.40846154 7.76923077,1.15076923 8.19461538,1.15076923 L9.93,1.15076923 C11.0984615,1.15076923 11.3876923,2.11538462 11.3876923,3.13384615 L11.3876923,3.64846154" id="Path"></path>
                </g>
            </g>
        </g>
    </g>
  </svg>
)
/* --------------------------------------------- */
DeleteIconLine.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object
}
/* --------------------------------------------- */
DeleteIconLine.defaultProps = {
  color: 'transparent',
  style: {
    width: 25,
    height: 25
  }
}
/* --------------------------------------------- */
export default DeleteIconLine
/* --------------------------------------------- */
